document.addEventListener('turbolinks:load', function () {
    if ($('.code_enforcements.new, .code_enforcements.create, .code_enforcements.edit, .code_enforcements.update').length === 0) {
        return false
    }

    processStep();

    function processStep() {
        $('.previous-step-btn').on('click', function (e) {
            e.preventDefault();

            var targetId = $(this).data("target")
            submitForm(targetId)
            window.scrollTo(0, 0)
        });

        $('.next-step-btn').on('click', function (e) {
            e.preventDefault();

            handleValidationAndSubmit($(this), e)
        });

        $('#v-organization-form-tab .form-tab').on('click', function (e) {
            e.preventDefault();

            showLoader();

            handleValidationAndSubmit($(this), e)
        });

        $('.saveBtn').on('click', function (e) {
            e.preventDefault();

            let element = $('#violationTab')
            let validationResult = validateRequiredFields(element);
            if (!validationResult.isValid) {
                if (validationResult.firstErrorField) {
                    validationResult.firstErrorField.focus();
                }
                hideLoader();
            } else {
                var saveCaseModal = new bootstrap.Modal(document.getElementById('saveCaseModal'));
                saveCaseModal.show();
            }
        });

        $('#saveCaseConfirmBtn').on('click', function (e) {
            e.preventDefault();
            var saveCaseModal = bootstrap.Modal.getInstance(document.getElementById('saveCaseModal'));
            if (saveCaseModal) {
                saveCaseModal.hide();
            }
            $('#section').val($('.tab-pane.fade.active.show').attr('id').slice(2));
            submitCodeEnforcementForm();
        });

        $('.submitBtn').on('click', function (e) {
            e.preventDefault();

            let element = $('#violationTab')
            let validationResult = validateRequiredFields(element);
            if (!validationResult.isValid) {
                if (validationResult.firstErrorField) {
                    validationResult.firstErrorField.focus();
                }
                hideLoader();
            } else {
                var submitCaseModal = new bootstrap.Modal(document.getElementById('submitCaseModal'));
                submitCaseModal.show();
            }
        });

        $('#submitCaseConfirmBtn').on('click', function (e) {
            e.preventDefault();
            var submitCaseModal = bootstrap.Modal.getInstance(document.getElementById('submitCaseModal'));
            if (submitCaseModal) {
                submitCaseModal.hide();
            }
            $('#section').val($('.tab-pane.fade.active.show').attr('id').slice(2));
            $('#complete_report').val(true);
            submitCodeEnforcementForm()
        });
    }

    // Add real-time validation for required fields
    $(document).on('blur', "input.requiredField, select.requiredField", function() {
        validateSingleField($(this));
    });

    $(document).on('change', "input.requiredField, select.requiredField", function() {
        validateSingleField($(this));
    });

    $(document).on('input', "input.requiredField", function() {
        validateSingleField($(this));
    });

    function handleValidationAndSubmit(element, event) {
        var targetId = $(element).data("target")
        var validationTabs = $(element).data('validation-tabs')
        var hasError = false
        $.each(validationTabs, function (index, tab) {
            var tabElement = $(`#${tab}`);
            if (tabElement.length !== 0) {
                let validationResult = validateRequiredFields(tabElement);
                if (!validationResult.isValid) {
                    const errorField = validationResult.firstErrorField;
                    if (errorField) {
                        const parentAccordian = errorField.closest('.accordion-item');
                        if(parentAccordian.length === 0) {
                            // forced focus
                            errorField.focus();
                        } else {
                            const button = parentAccordian.find('.accordion-button');
                            const collapse = parentAccordian.find('.accordion-collapse');

                            if(collapse.hasClass('show')) {
                                // handle separately for flatpickr fields
                                focusErrorField(errorField)
                            } else {
                                collapse.one('show.bs.collapse', function() {
                                    focusErrorField(errorField)
                                });

                                button.click();
                            }
                        }
                    }
                    hasError = true;
                    return false; // break out
                }
            }
        })

        if (hasError) {
            hideLoader();
        } else {
            submitForm(targetId)
            // hideLoader();
            window.scrollTo(0, 0)
        }
    }

    function focusErrorField(errorField) {
        if(errorField.hasClass('flatpickr-input', 'error-field')) {
            errorField.parent().find('.date-picker.input.error-field').focus();
        } else {
            errorField.focus();
        }
    }

    function validateRequiredFields(section) {
        let isValid = true;
        let firstErrorField = null;

        section.find('.requiredField').each(function() {
            let field = $(this);

            // cocoon hides a persisted nested-fields row on remove (setting its
            // _destroy flag) instead of deleting it from the DOM, so a required field
            // inside an already-removed element would otherwise still fail
            // validation and block navigation even though that field is no
            // longer part of the submission.
            let nestedFields = field.closest('.nested-fields');
            if (nestedFields.length) {
                let destroyField = nestedFields.find('input[name$="[_destroy]"]').first();
                if (destroyField.length && (destroyField.val() === '1' || destroyField.val() === 'true')) {
                    return;
                }
            }

            let container = field.closest('.form-field');
            let fieldValue = field.val();

            // Clear previous error state
            field.removeClass('is-invalid').removeClass('error-field');
            if (field.hasClass('select2-hidden-accessible')) {
                field.siblings('.select2-container').removeClass('is-invalid').removeClass('error-field');
            }
            container.find('.error-message').remove();

            if (fieldValue === null || fieldValue.length === 0 || fieldValue.trim() === '') {
                isValid = false;
                if (!firstErrorField) {
                    firstErrorField = field;
                }

                // Add error styling and message
                if (field.hasClass('select2-hidden-accessible')) {
                    field.siblings('.select2-container').addClass('is-invalid').addClass('error-field');
                } else {
                    field.addClass('is-invalid').addClass('error-field');
                }

                let errorMessage = field.attr('data-error-message') || container.attr('data-error-message');
                if (errorMessage) {
                    let errorElement = $('<div class="error-message text-danger small mt-1">' + errorMessage + '</div>');
                    container.append(errorElement);
                }
            }
        });

        return {
            isValid: isValid,
            firstErrorField: firstErrorField
        };
    }

    function validateSingleField(field) {
        let fieldValue = field.val();
        let container = field.closest('.form-field');

        field.removeClass('is-invalid').removeClass('error-field');
        container.find('.error-message').remove();

        if (fieldValue === null || fieldValue.length === 0 || fieldValue.trim() === '') {
            field.addClass('is-invalid').addClass('error-field');

            let errorMessage = field.attr('data-error-message') || container.attr('data-error-message');
            if (errorMessage) {
                let errorElement = $('<div class="error-message text-danger small mt-1">' + errorMessage + '</div>');
                container.append(errorElement);
            }
        }
    }

    function submitForm(targetId) {
        assignFormValue(targetId)
        submitCodeEnforcementForm()
    }

    function assignFormValue(targetId) {
        $('#next_tab_id').val(targetId);
        $('#section').val($('.tab-pane.fade.active.show').attr('id').slice(2));
    }

    function submitCodeEnforcementForm() {
        let form = document.querySelector('#code-enforcement-form');

        // Add submit event listener to show loader only when form is actually submitted
        form.addEventListener('submit', function() {
            showLoader();
        });

        let button = document.createElement('input');
        button.style.display = 'none';
        button.type = 'submit';
        form.appendChild(button).click();
        form.removeChild(button);
    }

    function showLoader() {
        $('.loading-spinner').show();
        $('body').css({
            pointerEvents: "none"
        })
    }

    function hideLoader() {
        $('.loading-spinner').hide();
        $('body').css({
            pointerEvents: "auto"
        });
    }
});